import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useMemo } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useContext } from "react";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function MonthlyRevenue({
  //labels = [],
  //datasets = [],
  thisYear,
  lastYear,
  title = "",
  height = 300,
  showLegend = true,
}) {
    const { t } = useContext(LocaleContext);
    // Sample data (replace with props or API data)
    const labels = ["Jan", "Feb", "Mar", "Apr", "May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const datasets = [
    {
      label: t("thisYear"),
      data: thisYear || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: "rgba(53, 162, 235, 0.3)",
      tension: 0.4, // smooth curve
    },
    {
      label: t("lastYear"),
      data: lastYear || [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.3)",
      tension: 0.4,
    },
  ];
  // Memoized data for performance
  const data = useMemo(() => {
    return {
      labels,
      datasets,
    };
  }, [labels, datasets]);

  // Memoized options
  const options = useMemo(() => {
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: showLegend,
          position: "top",
        },
        title: {
          display: !!title,
          text: title,
        },
        tooltip: {
          enabled: true,
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
        },
        y: {
          beginAtZero: false, // you can set true for all positive numbers
        },
      },
    };
  }, [title, showLegend]);

  // Empty state handling
  if (!labels.length || !datasets.length) {
    return <p style={{ textAlign: "center" }}>No data available</p>;
  }

  return (
    <div style={{ height }}>
      <Line data={data} options={options} />
    </div>
  );
}